let SVGPropNames;

// https://facebook.github.io/react/docs/tags-and-attributes.html#svg-attributes
SVGPropNames = [
    'clipPath',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'fill',
    'fillOpacity',
    'fontFamily',
    'fontSize',
    'fx',
    'fy',
    'gradientTransform',
    'gradientUnits',
    'markerEnd',
    'markerMid',
    'markerStart',
    'offset',
    'opacity',
    'patternContentUnits',
    'patternUnits',
    'points',
    'preserveAspectRatio',
    'r',
    'rx',
    'ry',
    'spreadMethod',
    'stopColor',
    'stopOpacity',
    'stroke',
    'strokeDasharray',
    'strokeLinecap',
    'strokeOpacity',
    'strokeWidth',
    'textAnchor',
    'transform',
    'version',
    'viewBox',
    'x1',
    'x2',
    'x',
    'y1',
    'y2',
    'y'
];

export default SVGPropNames;
